<template>
  <div class="register-info">
    <div class="register-info-wrapper">
      <div class="register-info-item">
        <label>{{ $t("system.Account") }}</label>
        <span>
          <input type="text" :placeholder="$t('placeholders.Account')" v-model="value.UserAct" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="register-info-item">
        <label>{{ $t("system.Password") }}</label>
        <span>
          <input :placeholder="$t('placeholders.Password')" v-model="value.UserPwd" type="password" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="register-info-item">
        <label>{{ $t("system.AffirmNewPassword") }}</label>
        <span>
          <input :placeholder="$t('placeholders.AffirmNewPassword')" v-model="value.ConfirmPwd" type="password" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="register-info-item">
        <label>{{ $t("system.VerificationCode") }}</label>
        <span>
          <input :placeholder="$t('placeholders.VerificationCode')" style="width: 1.5rem;vertical-align: middle" v-model="value.ValidCode" type="text" />
          <img :src="checkImageUrl" class="valid-image" style="vertical-align: middle" @click="ReloadImage" />
        </span>
      </div>
      <div class="border_bottom"></div>
      <div class="register-info-item">
        <label>{{ $t("system.DynamicCode") }}</label>
        <span>
          <input :placeholder="$t('placeholders.DynamicCode')" v-model="value.MobileCode" type="password" style="width: 1.5rem" />
          <span style=" font-size: 0.399rem;color: #12a3ff;display: inline-block " v-if="judgeCode" @click="sendCode">{{ textCode }}</span>
          <span style=" font-size: 0.399rem;color: #12a3ff;display: inline-block " v-else :style="{ color: !judgeCode ? '#666' : '' }">{{ textCode }}</span>
        </span>
      </div>
      <div style="padding:  0.532rem 0">
        <div>
          <input type="checkbox" id="protocol" style="vertical-align: middle" v-model="isAgree" />
          <label style="vertical-align: middle" for="protocol">{{ $t("system.ServiceAgreement") }}</label>
        </div>
        <div class="register-btn">
          <div v-if="isAgree" class="active" @click="register">{{ $t("system.Register") }}</div>
          <div v-else>{{ $t("system.Register") }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
  .register-info-item {
    display: flex;
    align-items: center;
    height: 1.197rem;
  }

  .register-info-item label {
    display: inline-block;
    width: 2.66rem;
    height: 0.798rem;
    line-height: 0.798rem;
  }

  .register-info-item span {
    display: inline-block;
    height: 0.798rem;
    font-size: 0.399rem;
    line-height: 0.798rem;
  }

  .register-info-item input {
    border: 0;
    height: 100%;
  }

  .register-btn {
    margin-top: 0.532rem;
  }

  .register-btn div {
    margin: 0 auto;
    background-color: #eef1f6;
    height: 0.93rem;
    line-height: 0.93rem;
    width: 7.98rem;
    color: #bfcbd9;
    border-radius: 0.106rem;
    text-align: center;
  }

  .register-btn .active {
    background-color: #12a3ff;
    color: #fff;
  }
</style>
<script>
  import sideService from "@/service/sideService";
  export default {
    data() {
      return {
        textCode: this.$root.$t("system.SendDynamicCode"),
        judgeCode: true,
        setInterval: null,
        checkImageUrl: "",
        isAgree: true,
      };
    },
    props: ["currentView", "value", "model"],
    mounted() {
      this.ReloadImage();
    },
    computed: {
      RoleTypeTypes() {
        return this.$store.getters.categorys.types.RoleType;
      },
      ticketInfo() {
        return this.profile;
      },
    },
    methods: {
      register() {
        let __self = this;
        let RegExp = $utils.RegExp;
        // if (__self.model.UserAccount.UserAct == "") {
        //   return $utils.fail(__self.$t('RegExp.AccountReg.isEmpty'), 'fail')
        // }
        // if (!(RegExp.MobileReg.test(__self.model.UserAccount.UserAct) || RegExp.EmailReg.test(__self.model.UserAccount.UserAct))) {
        //   return $utils.fail(__self.$t('RegExp.AccountReg.isFormat'), 'fail')
        // }
        // if (__self.model.UserAccount.UserPwd == "") {
        //   return $utils.fail(__self.$t('RegExp.PwdReg.isEmpty'), 'fail')
        // }
        // if (!RegExp.PwdReg.test(__self.model.UserAccount.UserPwd)) {
        //   return $utils.fail(__self.$t('RegExp.PwdReg.isEmpty'), 'fail')
        // }
        // if (__self.model.UserAccount.ConfirmPwd == "") {
        //   return $utils.fail(__self.$t('RegExp.ConfigPwd.isEmpty'), 'fail')
        // }
        // if (__self.model.UserAccount.ConfirmPwd != __self.model.UserAccount.UserPwd) {
        //   return $utils.fail(__self.$t('RegExp.ConfigPwd.isEmpty'), 'fail')
        // }
        // if (__self.model.UserAccount.ValidCode == "") {
        //   return $utils.fail(__self.$t('RegExp.VerificationCodeReg.isEmpty'), 'fail')
        // }
        // if (__self.model.UserAccount.MobileCode == "") {
        //   return $utils.fail(__self.$t('RegExp.DynamicCodeReg.isEmpty'), 'fail')
        // }
        // if (!__self.isAgree) {
        //   return $utils.fail(__self.$t('RegExp.ProtocolReg.isFlag'), 'fail')
        // }
        if (__self.currentView == "userRegister") {
          __self.model.RoleType = __self.RoleTypeTypes.User;
          __self.model.RoleName = __self.model.UserAccount.UserAct;
        } else {
          __self.model.RoleType = __self.RoleTypeTypes.Company;
          __self.model.ContactInfo.ContactPeople = __self.model.ContactName;
        }
        UserService.register(__self.model).then(json => {
          if (json.isSucc) {
            this.$root.$toast.success(__self.$t("share.succ.RegisteredSucc"));
            return __self.$router.push({
              path: "/login",
            });
          }
        });
      },
      ReloadImage() {
        let __self = this;
        __self.checkImageUrl = sideService.getValidImageUrl();
      },
      sendCode() {
        let __self = this;
        if (__self.value.UserAct == "") {
          return $utils.fail(__self.$t("share.fail.RegisterPhone"), "fail");
        }
        if (__self.value.validCode == "") {
          return $utils.fail(__self.$t("share.fail.VerificationCode"), "fail");
        }
        if (__self.judgeCode) {
          let $time = 60;
          UserService.sendCode(__self.value).then(json => {
            if (json.isSucc) {
              this.$root.$toast.success(json.message, "succ");
              __self.judgeCode = false;
              __self.setInterval = setInterval(run, 1000);

              function run() {
                __self.textCode = "(" + __self.$t("system.Sent") + --$time + ")";
                if ($time <= 0) {
                  clearInterval(__self.setInterval);
                  __self.textCode = __self.$t("system.SendDynamicCode");
                  __self.judgeCode = true;
                }
              }
            }
          });
        }
      },
    },
  };
</script>
